import React from "react";
import {settingDirection} from "../helpers/teamReassessment";
import { useTranslation } from "react-i18next";
import { goalFieldLabel } from "../helpers/teamSettingValues";
export default function TeamValueChanges({
  rows,
  en = false,
  names = (id) => id,
  registry,
}) {
  const { i18n } = useTranslation();
  const groupName = (g) =>
    g === "conversion"
      ? "Conversion"
      : i18n.t(
          "help.automation.business.statisticNames." + registry?.[g]?.title,
          { defaultValue: registry?.[g]?.title || g }
        );
  const t = (d, e) => (en ? e : d),
    fmt = (n) =>
      Number.isFinite(n)
        ? n.toLocaleString(en ? "en-GB" : "de-DE", { maximumFractionDigits: 6 })
        : "—";
  return (
    <div className="ta-scroll">
      <table className="tw-value-changes">
        <thead>
          <tr>
            <th>{t("Team / Modell / Feld", "Team / model / field")}</th>
            <th>{t("Bisher gespeichert", "Previously saved")}</th>
            <th>{t("Neuer Wert", "New value")}</th>
            <th>Δ</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <th>
                {names(r.id)} ·{" "}
                {r.model === "result"
                  ? t("Ergebnismodell", "Results model")
                  : t("Statistikmodell", "Statistics model")}{" "}
                · {r.group && groupName(r.group) + " · "}
                {goalFieldLabel(r.field, en)}
              </th>
              <td>{fmt(r.before)}</td>
              <td>{fmt(r.after)}</td>
              <td className={settingDirection(r.field,r.before,r.after,r.group)>0?"tw-positive":settingDirection(r.field,r.before,r.after,r.group)<0?"tw-negative":""}>
                {Number.isFinite(r.before) && r.after - r.before > 0 ? "+" : ""}
                {fmt(
                  Number.isFinite(r.before) && Number.isFinite(r.after)
                    ? r.after - r.before
                    : null
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!rows.length && (
        <p>
          {t("Keine Einzelwerte geändert.", "No individual values changed.")}
        </p>
      )}
    </div>
  );
}
